module.exports = __webpack_public_path__ + "static/media/disabledCrossIcon.a2f88d2c.svg";